import React, { useEffect, useState } from 'react';
import { Card } from '../ui/card';
import { Radar, PhoneCall, CalendarCheck, MailCheck, Sparkles, BadgeCheck } from 'lucide-react';
import api from '../../lib/api';

const STATS = [
  { key: 'prospected', label: 'Prospected', icon: Radar, color: 'text-emerald-400' },
  { key: 'revealed', label: 'Contacts revealed', icon: BadgeCheck, color: 'text-amber-400' },
  { key: 'instant_callbacks', label: 'Instant callbacks', icon: PhoneCall, color: 'text-sky-400' },
  { key: 'meetings_booked', label: 'Meetings booked', icon: CalendarCheck, color: 'text-violet-400' },
  { key: 'auto_replies', label: 'Auto-replies', icon: MailCheck, color: 'text-pink-400' },
];

// Dashboard insight — what the autonomous engine did over the last 7 days.
export const AutonomyInsightsCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/api/brain/autonomy-insights')
      .then((res) => setData(res.data))
      .catch(() => {});
  }, []);

  if (!data) return null;
  const c = data.counts || {};
  if ((data.total_actions || 0) === 0) return null; // hide until the engine has acted

  return (
    <Card className="p-5 border-emerald-500/20 bg-gradient-to-br from-emerald-500/[0.06] to-transparent" data-testid="autonomy-insights-card">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="h-4 w-4 text-emerald-400" />
        <h3 className="text-sm font-semibold text-foreground">Autonomy Insights</h3>
        <span className="text-xs text-muted-foreground">· last {data.window_days} days</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {STATS.map(({ key, label, icon: Icon, color }) => (
          <div key={key} className="rounded-lg border border-border/40 bg-card/40 p-3" data-testid={`autonomy-stat-${key}`}>
            <Icon className={`h-4 w-4 ${color} mb-1.5`} />
            <p className="text-2xl font-bold text-foreground leading-none">{c[key] ?? 0}</p>
            <p className="text-[11px] text-muted-foreground mt-1">{label}</p>
          </div>
        ))}
      </div>
      {data.recent_prospects?.length > 0 && (
        <div className="mt-4 pt-3 border-t border-border/40">
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground mb-2">Recently prospected</p>
          <div className="flex flex-wrap gap-1.5">
            {data.recent_prospects.map((p, i) => (
              <span key={i} className="text-xs px-2 py-1 rounded-md bg-card/60 border border-border/40 text-foreground/80" data-testid="autonomy-recent-prospect">
                {p.company}{p.contact_revealed ? ' ✓' : ''}
              </span>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
};

export default AutonomyInsightsCard;
